<template>
  <div class="cocina" :class="{ 'cocina--entrega': modoEntrega }">
    <div class="cocina__resumen">
      <span class="cocina__hora"><v-icon small class="mr-1">mdi-clock-outline</v-icon>{{ horaActual }}</span>
      <span class="cocina__total">{{ abiertos.length }} {{ abiertos.length === 1 ? "pedido" : "pedidos" }} {{ modoEntrega ? "por entregar" : "abiertos" }}</span>
      <span v-if="atrasados" class="cocina__atrasados">
        <v-icon small color="inherit" class="mr-1">mdi-alert-circle-outline</v-icon>{{ atrasados }}
        {{ atrasados === 1 ? "atrasado" : "atrasados" }}
      </span>
      <div class="cocina__derecha">
      <v-btn v-if="timbrando" small rounded depressed dark color="#a31d48" class="cocina__silenciar" @click="silenciar">
        <v-icon small left>mdi-bell-off-outline</v-icon>Silenciar ({{ sinAceptar.length }} sin aceptar)
      </v-btn>
      <v-btn v-if="sonido && !audioListo" small rounded depressed color="warning" class="cocina__activar" @click="prepararAudio">
        <v-icon small left>mdi-gesture-tap</v-icon>Toca aquí para activar el sonido
      </v-btn>
      <v-btn v-if="!modoEntrega" small rounded outlined color="#a31d48" class="cocina__listos" @click="verListos = true">
        <v-icon small left>mdi-check-all</v-icon>Listos ({{ ordersPrepared.length }})
      </v-btn>
      <v-btn v-else small rounded outlined color="#2e7d5b" class="cocina__listos" @click="verEntregados = true">
        <v-icon small left>mdi-check-all</v-icon>Entregados ({{ ordersDelivered.length }})
      </v-btn>
      <v-btn small rounded outlined class="cocina__sonido" :color="sonido ? 'success' : 'grey'" @click="alternarSonido">
        <v-icon small left>{{ sonido ? "mdi-volume-high" : "mdi-volume-off" }}</v-icon>
        {{ sonido ? "Sonido activado" : "Sonido apagado" }}
      </v-btn>
      </div>
    </div>
    <section v-if="modoEntrega" class="cocina__columna">
      <header class="cocina__titulo cocina__titulo--preparando">
        <span>Por entregar <small class="cocina__orden">· el más antiguo primero</small></span>
        <span class="cocina__conteo">{{ ordersToDeliver.length }}</span>
      </header>
      <div v-if="ordersToDeliver.length > 0" class="cocina__tarjetas">
        <TarjetaPedido v-for="(item, i) in ordersToDeliver" :key="item.id" :item="item" :ahora="ahora" :posicion="i + 1" modo-entrega
          @accion="entregar(item)" />
      </div>
      <div v-else class="cocina__vacio">
        <v-icon large color="grey lighten-1">mdi-package-variant-closed-check</v-icon>
        <p>No hay pedidos por entregar</p>
      </div>
    </section>

    <section v-if="!modoEntrega" class="cocina__columna">
      <header class="cocina__titulo cocina__titulo--recibidas">
        <span>Recibidas <small class="cocina__orden">· el más antiguo primero</small></span>
        <span class="cocina__conteo">{{ ordersReceived.length }}</span>
      </header>
      <div v-if="ordersReceived.length > 0" class="cocina__tarjetas">
        <TarjetaPedido v-for="(item, i) in ordersReceived" :key="item.id" :item="item" :ahora="ahora" :posicion="i + 1"
          @accion="start(item)" @ver-producto="verProducto" />
      </div>
      <div v-else class="cocina__vacio">
        <v-icon large color="grey lighten-1">mdi-silverware-variant</v-icon>
        <p>No hay pedidos por preparar</p>
      </div>
    </section>

    <section v-if="!modoEntrega" class="cocina__columna">
      <header class="cocina__titulo cocina__titulo--preparando">
        <span>En preparación <small class="cocina__orden">· el más antiguo primero</small></span>
        <span class="cocina__conteo">{{ ordersPreparing.length }}</span>
      </header>
      <div v-if="ordersPreparing.length > 0" class="cocina__tarjetas">
        <TarjetaPedido v-for="(item, i) in ordersPreparing" :key="item.id" :item="item" :ahora="ahora" :posicion="i + 1" en-preparacion
          @accion="finished(item)" @ver-producto="verProducto" @iniciar-linea="startItem(item, $event)" @terminar-linea="finishItem(item, $event)" @imposible-linea="imposibleItem(item, $event, arguments[1])" />
      </div>
      <div v-else class="cocina__vacio">
        <v-icon large color="grey lighten-1">mdi-pot-steam-outline</v-icon>
        <p>Nada en preparación</p>
      </div>
    </section>

    <v-dialog v-model="verFicha" max-width="560" scrollable>
      <v-card>
        <v-card-title class="cocina__listos-titulo">
          <v-icon color="#a31d48" class="mr-2">mdi-silverware-fork-knife</v-icon>{{ ficha ? ficha.nombre : productoElegido }}
          <v-spacer></v-spacer>
          <v-btn icon @click="verFicha = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-2 ficha">
          <v-progress-linear v-if="cargandoFicha" indeterminate color="#a31d48" />
          <p v-else-if="errorFicha" class="ficha__vacio">{{ errorFicha }}</p>
          <template v-else-if="ficha">
            <h4 class="ficha__titulo">Descripción</h4>
            <p v-if="ficha.descripcion" class="ficha__texto">{{ ficha.descripcion }}</p>
            <p v-else class="ficha__vacio">Este producto no tiene descripción.</p>

            <template v-if="ficha.es_combo">
              <h4 class="ficha__titulo">El combo incluye</h4>
              <ul v-if="ficha.componentes.length" class="ficha__lista">
                <li v-for="(c, i) in ficha.componentes" :key="'c' + i"><b>{{ cantidad(c.cantidad) }}</b> {{ c.unidad }} {{ c.nombre }}</li>
              </ul>
              <p v-else class="ficha__vacio">Este combo no tiene productos registrados.</p>
            </template>

            <h4 class="ficha__titulo">Se prepara con</h4>
            <ul v-if="ficha.materias_primas.length" class="ficha__lista">
              <li v-for="(m, i) in ficha.materias_primas" :key="'m' + i"><b>{{ cantidad(m.cantidad) }}</b> {{ m.unidad }} de {{ m.nombre }}</li>
            </ul>
            <p v-else class="ficha__vacio">No tiene receta registrada (materias primas).</p>

            <p class="ficha__pie">Si algo falta o está mal, se corrige en el ERP, en el producto.</p>
          </template>
        </v-card-text>
        <v-card-actions class="px-6 pb-5">
          <v-spacer></v-spacer>
          <v-btn large depressed dark color="#a31d48" @click="verFicha = false">Entendido</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="hayAvisoEntrega" color="error" :timeout="6000">{{ avisoEntrega }}</v-snackbar>

    <v-dialog v-model="verEntregados" max-width="720" scrollable>
      <v-card>
        <v-card-title class="cocina__listos-titulo">
          <v-icon color="#2e7d5b" class="mr-2">mdi-check-all</v-icon>Pedidos entregados del turno
          <v-spacer></v-spacer>
          <v-btn icon @click="verEntregados = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-2">
          <div v-if="ordersDelivered.length === 0" class="cocina__vacio">
            <v-icon large color="grey lighten-1">mdi-check-all</v-icon>
            <p>Todavía no hay pedidos entregados en este turno</p>
          </div>
          <div v-for="o in ordersDelivered" :key="o.id" class="listo">
            <div class="listo__cabecera">
              <span class="listo__mesa"><v-icon class="mr-1">mdi-receipt-text-outline</v-icon>Pedido {{ o.consecutive_order_text || "" }}</span>
              <span class="listo__tiempo">{{ textoEntregado(o) }}</span>
            </div>
            <div class="listo__lineas">
              <span v-for="it in o.data_items" :key="it.id">
                x{{ it.quantity }} {{ it.product.name }}<em v-if="it.note"> ({{ it.note }})</em>
              </span>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="verListos" max-width="720" scrollable>
      <v-card>
        <v-card-title class="cocina__listos-titulo">
          <v-icon color="#2e7d5b" class="mr-2">mdi-check-all</v-icon>Pedidos listos del turno
          <v-spacer></v-spacer>
          <v-btn icon @click="verListos = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-2">
          <div v-if="ordersPrepared.length === 0" class="cocina__vacio">
            <v-icon large color="grey lighten-1">mdi-check-all</v-icon>
            <p>Todavía no hay pedidos listos en este turno</p>
          </div>
          <div v-for="o in ordersPrepared" :key="o.id" class="listo">
            <div class="listo__cabecera">
              <span class="listo__mesa"><v-icon class="mr-1">mdi-table-furniture</v-icon>{{ o.name_table || "Sin mesa" }}</span>
              <span class="listo__tiempo">{{ textoTerminado(o) }}</span>
            </div>
            <div class="listo__lineas">
              <span v-for="it in o.data_items" :key="it.id">
                x{{ it.quantity }} {{ it.product.name }}<em v-if="it.note"> ({{ it.note }})</em>
              </span>
            </div>
            <v-btn small rounded outlined color="#a31d48" class="mt-2" @click="devolver(o)">
              <v-icon small left>mdi-undo-variant</v-icon>Devolver a preparación
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as moment from "moment-timezone";
import { cargarAgotados } from "@/plugins/pos/agotados";
import TarjetaPedido from "./TarjetaPedido.vue";

// "ta-ra-ra-RA, ta-ra-RA": [segundo en que entra, frecuencia en Hz, duración en s].
const NOTAS = [
  [0.0, 784, 0.25],
  [0.16, 784, 0.25],
  [0.32, 784, 0.25],
  [0.48, 1047, 0.6],
  [1.15, 784, 0.25],
  [1.31, 784, 0.25],
  [1.47, 1047, 0.75],
];

function leerSonido() {
  try {
    return localStorage.getItem("cocina_sonido") !== "0";
  } catch (e) {
    return true;
  }
}

export default {
  components: { TarjetaPedido },
  name: "TodoList",
  data: () => ({
    orders: [],
    ahora: Date.now(),
    reloj: null,
    // Aviso sonoro de pedidos nuevos: se recuerda en este equipo si se silenció.
    verListos: false,
    verEntregados: false,
    hayAvisoEntrega: false,
    avisoEntrega: "",
    verFicha: false,
    ficha: null,
    productoElegido: "",
    cargandoFicha: false,
    errorFicha: "",
    fichas: {},
    sonido: leerSonido(),
    conocidos: {},
    cargado: false,
    audio: null,
    audioListo: false,
    ultimoCiclo: -10,
    silenciada: false,
    nuevos: {},
    timbre: null,
    key: 0,
    keyItemsChangeStatus: 1,
  }),
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    // La lista se arma al abrir: antes solo se pedía cuando cambiaba la sucursal, y con la sucursal ya elegida
    // (o recordada) la cocina se veía vacía hasta que llegara un aviso.
    if (this.$store.getters.store) {
      this.getPendingOrders();
    }
    // Los navegadores no dejan sonar hasta que la persona toca la pantalla: el primer toque deja el audio listo.
    this.prepararAudio();
    this.timbre = setInterval(this.revisarTimbre, 500);
    window.addEventListener("pointerdown", this.alTocar);
    window.addEventListener("keydown", this.alTocar);
    // El tiempo de cada pedido (y su color) avanza solo.
    this.reloj = setInterval(() => {
      this.ahora = Date.now();
    }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.reloj);
    window.removeEventListener("pointerdown", this.alTocar);
    window.removeEventListener("keydown", this.alTocar);
    clearInterval(this.timbre);
  },
  computed: {
    // Pedidos que llegaron con la pantalla abierta y nadie ha aceptado (pulsando "Preparar"): mientras
    // haya alguno, el timbre sigue sonando.
    sinAceptar() {
      return this.orders.filter((o) => o.order_status === "received" && this.nuevos[o.id]);
    },
    timbrando() {
      return this.sonido && !this.silenciada && this.sinAceptar.length > 0;
    },
    horaActual() {
      return new Date(this.ahora).toLocaleTimeString("es-CO", { hour: "2-digit", minute: "2-digit" });
    },
    // Los que siguen en la cocina: el servidor también manda los ya terminados del turno.
    abiertos() {
      if (this.modoEntrega) return this.ordersToDeliver;
      return this.orders.filter((o) => ["received", "preparing"].includes(o.order_status));
    },
    // Negocios que no son restaurante: no se prepara, el pedido ya está cobrado y solo falta entregarlo.
    modoEntrega() {
      return !this.$store.getters.isRestaurant;
    },
    ordersToDeliver() {
      const cobrado = (o) => o.closing_date || o.opening_date || o.date_order || "";
      return this.orders.filter((o) => o.delivery_status === "pending").sort((a, b) => (cobrado(a) < cobrado(b) ? -1 : cobrado(a) > cobrado(b) ? 1 : 0));
    },
    // El último entregado arriba.
    ordersDelivered() {
      return this.orders.filter((o) => o.delivery_status === "delivered").sort((a, b) => String(b.delivered_at || "").localeCompare(String(a.delivered_at || "")));
    },
    // Los finalizados del turno, el último terminado arriba.
    ordersPrepared() {
      const fin = (o) => o.preparing_end || o.opening_date || "";
      return this.orders.filter((o) => o.order_status === "prepared").sort((a, b) => (fin(a) < fin(b) ? 1 : fin(a) > fin(b) ? -1 : 0));
    },
    // Pedidos con 20 minutos o más esperando (el mismo límite en que la tarjeta se pone roja).
    atrasados() {
      return this.abiertos.filter((o) => {
        const desde = (this.modoEntrega && o.closing_date) || o.opening_date || o.date_order;
        return desde && this.ahora - moment.tz(desde, "America/Bogota").valueOf() >= 20 * 60000;
      }).length;
    },
    // El más viejo primero: es el que lleva más esperando.
    ordersReceived() {
      return this.porAntiguedad(this.orders.filter((el) => el.order_status === "received"));
    },
    ordersPreparing() {
      return this.porAntiguedad(this.orders.filter((el) => el.order_status === "preparing"));
    },
  },
  watch:{
    // Suena cuando aparece un pedido recibido que la cocina no tenía. La primera carga no suena.
    orders() {
      let hayNuevo = false;
      let hayNuevoPorEntregar = false;
      for (const o of this.orders) {
        if (!this.conocidos[o.id]) {
          this.conocidos[o.id] = true;
          if (this.modoEntrega && o.delivery_status === "pending") {
            hayNuevoPorEntregar = true;
          } else if (o.order_status === "received") {
            hayNuevo = true;
            if (this.cargado) this.$set(this.nuevos, o.id, true);
          }
        }
      }
      // Por entregar: suena una sola vez, no hay nada que «aceptar».
      if (hayNuevoPorEntregar && this.cargado && this.sonido) this.sonarCiclo();
      // Un pedido nuevo vuelve a activar el timbre aunque se hubiera silenciado el anterior.
      if (hayNuevo && this.cargado) {
        this.silenciada = false;
        this.$nextTick(this.revisarTimbre);
      }
    },
    '$store.getters.store': function () {
      console.log('watch oreders listener....')
      this.getPendingOrders();
    }
  },
  methods: {
    prepararAudio() {
      try {
        if (!this.audio) {
          this.audio = new (window.AudioContext || window.webkitAudioContext)();
          this.audio.onstatechange = () => (this.audioListo = this.audio.state === "running");
        }
        if (this.audio.state === "suspended") this.audio.resume();
        this.audioListo = this.audio.state === "running";
      } catch (e) {
        this.audio = null;
      }
    },
    // Cualquier toque a la pantalla deja el audio listo (los navegadores no dejan sonar antes).
    alTocar() {
      this.prepararAudio();
    },
    // Una vuelta del timbre: "ta-ra-ra-RA, ta-ra-RA" con sonido de campanita. Dura unos 2,4 s.
    sonarCiclo() {
      this.prepararAudio();
      if (!this.audio) return;
      const ctx = this.audio;
      const t0 = ctx.currentTime + 0.05;
      this.ultimoCiclo = ctx.currentTime;
      const maestro = ctx.createGain();
      maestro.gain.value = 0.9;
      maestro.connect(ctx.destination);
      NOTAS.forEach(([dt, hz, dur]) => {
        const inicio = t0 + dt;
        const env = ctx.createGain();
        env.gain.setValueAtTime(0.0001, inicio);
        env.gain.linearRampToValueAtTime(0.42, inicio + 0.004);
        env.gain.setTargetAtTime(0, inicio + 0.004, dur * 0.55);
        env.connect(maestro);
        // Una campana: el tono y dos armónicos más suaves.
        [[1, 1], [2, 0.5], [3.01, 0.25]].forEach(([mult, vol]) => {
          const o = ctx.createOscillator();
          const g = ctx.createGain();
          o.frequency.value = hz * mult;
          g.gain.value = vol;
          o.connect(g).connect(env);
          o.start(inicio);
          o.stop(inicio + dur + 0.6);
        });
      });
    },
    // Cada 2,4 s, si hay pedidos nuevos sin aceptar y no se silenció, suena otra vuelta.
    revisarTimbre() {
      if (!this.timbrando || !this.audioListo) return;
      if (this.audio.currentTime - this.ultimoCiclo < 2.3) return;
      this.sonarCiclo();
    },
    silenciar() {
      this.silenciada = true;
    },
    alternarSonido() {
      this.sonido = !this.sonido;
      try {
        localStorage.setItem("cocina_sonido", this.sonido ? "1" : "0");
      } catch (e) {}
      // Al encenderlo suena una vez, para comprobar que se oye.
      if (this.sonido) this.sonarCiclo();
    },
    // La ficha del producto (descripción, receta, componentes del combo): se pide una vez y se recuerda.
    async verProducto(producto) {
      this.verFicha = true;
      this.productoElegido = producto.name;
      this.errorFicha = "";
      if (this.fichas[producto.id]) {
        this.ficha = this.fichas[producto.id];
        return;
      }
      this.ficha = null;
      this.cargandoFicha = true;
      try {
        const res = await this.$http.get("api/v1/pos/cocina/productos/" + producto.id);
        if (res && res.success) {
          this.fichas[producto.id] = res.ficha;
          this.ficha = res.ficha;
        } else {
          this.errorFicha = (res && res.message) || "No se pudo cargar la información del producto.";
        }
      } catch (e) {
        this.errorFicha = "No se pudo cargar la información del producto. Revisa la conexión.";
      } finally {
        this.cargandoFicha = false;
      }
    },
    // 0.300 → "0.3"; 2 → "2".
    cantidad(n) {
      return Number(n).toString();
    },
    // "Terminó a las 3:45 p. m. · tardó 12 min".
    textoTerminado(o) {
      if (!o.preparing_end) return "Terminado";
      const fin = moment.tz(o.preparing_end, "America/Bogota");
      const desde = o.preparing_start || o.opening_date || o.date_order;
      const min = desde ? Math.max(0, Math.round(fin.diff(moment.tz(desde, "America/Bogota")) / 60000)) : null;
      return `Terminó a las ${fin.format("h:mm a")}` + (min !== null ? ` · tardó ${min} min` : "");
    },
    // Lo marcaron listo por error: vuelve a la columna "En preparación" con sus líneas como estaban.
    devolver(o) {
      this.start(o);
    },
    // «Entregó Luis Pérez a las 3:45 p. m.»: lo guarda el servidor con el usuario en sesión.
    textoEntregado(o) {
      const cuando = o.delivered_at ? moment.tz(o.delivered_at, "America/Bogota").format("h:mm a") : "";
      return "Entregó " + (o.delivered_by_name || "—") + (cuando ? " a las " + cuando : "");
    },
    async entregar(o) {
      try {
        const res = await this.$http.post("api/v1/pos/pedidos/" + o.id + "/entregar", {});
        if (res && res.success) {
          this.$set(o, "delivery_status", "delivered");
          this.$set(o, "delivered_by_name", res.item && res.item.delivered_by_name);
          this.$set(o, "delivered_at", res.item && res.item.delivered_at);
          return;
        }
        this.avisoEntrega = (res && (res.message || res.msg)) || "No se pudo marcar como entregado.";
      } catch (e) {
        this.avisoEntrega = (e && (e.message || e.msg)) || "No se pudo marcar como entregado. Revisa la conexión.";
      }
      this.hayAvisoEntrega = true;
      this.getPendingOrders();
    },
    porAntiguedad(lista) {
      const fecha = (o) => o.opening_date || o.date_order || "";
      return [...lista].sort((a, b) => (fecha(a) < fecha(b) ? -1 : fecha(a) > fecha(b) ? 1 : 0));
    },
    getTotalItems(item) {
      return item.data_items.reduce((acc, it) => acc + it.quantity, 0);
    },
    getChipColor(status) {
      if (status === "prepared") {
        return "green";
      } else if (status === "preparing") {
        return "orange";
      } else {
        // Manejo de un caso por defecto
        return "grey"; // o cualquier otro color por defecto que desees
      }
    },
    getTotalItemsPreparing(item) {
      return item.data_items.reduce((acc, it) => {
        if (it.status === "preparing") {
          return acc + it.quantity;
        }
        return 0;
      }, 0);
    },
    getTotalItemsPrepared(item) {
      return item.data_items.reduce((acc, it) => {
        if (it.status === "prepared") {
          return acc + it.quantity;
        }
        return 0;
      }, 0);
    },
    startItem(order, it) {
      this.$set(it, "status", "preparing");
      this.$set(it, "start", Date.now());
      this.$set(order, "start", Date.now());
      //console.log(it)
      this.currentItemId = it.id;
      this.$http
        .post(
          "api/v1/order-change-status-item/" + order.id + "/" + it.id + "",
          { status: "preparing", start: it.start }
        )
        .then((response) => {
          if (response && response.success) {
          }
        });
    },
    imposibleItem(order, it, motivo) {
      this.$http
        .post("api/v1/order-change-status-item/" + order.id + "/" + it.id + "", { status: "unavailable", ...motivo })
        .then((response) => {
          if (response && response.success) {
            this.$set(it, "status", "unavailable");
            cargarAgotados(this.$http);
            this.getPendingOrders();
          }
        });
    },
    finishItem(order, it) {
      this.$set(it, "status", "prepared");
      this.$set(it, "finished", Date.now());
      //this.$set(order, "finished", Date.now());
      //this.keyItemsChangeStatus++;
      this.currentItemId = it.id;
      this.$http
        .post(
          "api/v1/order-change-status-item/" + order.id + "/" + it.id + "",
          { status: "prepared", finished: it.finished }
        )
        .then((response) => {
          if (response && response.success) {

          }
        });
    },
    async getPendingOrders() {
      console.log("get pending orders..", this.$store.getters.store);
      if (this.$store.getters.store) {
        const subId = this.$store.getters.store.bus_subsidiary_id.id;
        return new Promise(async (resolve, reject) => {
          this.$http
            .get("api/v1/orders-pending-screen", {
              //from_seller: true,
              //order_status: ["received", "preparing"],
              subsidiary: [subId],
            })
            .then(async (response) => {
              // La primera lista no cuenta como nueva: solo suenan los que lleguen después.
              if (!this.cargado) {
                response.items.forEach((o) => (this.conocidos[o.id] = true));
                this.cargado = true;
              }
              this.$nextTick(() => {
                this.orders = response.items;
              });
              resolve(response.items);
              //this.$db.updateOrders( response.items );
            });
        });
      }
    },
    finished(item) {
      this.$http
        .post(
          "api/v1/order/change-status/" + item.id + "",
          { order_status: "prepared", time: this.$filters.currentDatetime() },
          true,
          true
        )
        .then((response) => {
          if (response && response.success) {
            //let indexToUpdate = this.orders.findIndex(el => el.id === item.id);
            item.order_status = "prepared";
          }
        });
    },
    start(item) {
      this.$http
        .post(
          "api/v1/order/change-status/" + item.id + "",
          { order_status: "preparing", time: this.$filters.currentDatetime() },
          true,
          true
        )
        .then((response) => {
          if (response && response.success) {
            //let indexToUpdate = this.orders.findIndex(el => el.id === item.id);
            item.order_status = "preparing";
          }
        });
      //item.order_status = 'preparing';
    },
    cancel() {
      this.clear();
      this.searched = false;
      this.key++;
      this.$emit("cancel");
    },
    clear() {
      this.item = JSON.parse(JSON.stringify(DEFAULT_ITEM));
    },
    addOrder(item) {

      if(this.orders.length == 0){
        this.orders.push(item);
      }else{
        let isNew = true;
        for (let i = 0; i < this.orders.length; i++) {
        if (this.orders[i].id === item.id) {
          // Actualizar el objeto existente en el array
          this.orders.splice(i, 1, JSON.parse(JSON.stringify(item)));
          isNew = false;
          break;
        }
      }
        if(isNew){
          this.orders.push(item);
        }
      }
      
    },
  },
};
</script>
<style scoped>
.cocina {
  min-height: calc(100vh - 64px);
  background: #f8f2f4;
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  padding: 16px;
  align-items: start;
}

@media (min-width: 900px) {
  .cocina {
    grid-template-columns: 1fr 1fr;
  }
}

.cocina--entrega {
  grid-template-columns: 1fr !important;
}

.cocina__resumen {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 20px;
  font-size: 1.05rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.65);
}

.cocina__hora {
  display: flex;
  align-items: center;
  font-size: 1.3rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
}

.cocina__derecha {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: auto;
}

.cocina__listos-titulo {
  font-weight: 800;
}

.ficha__titulo {
  margin: 16px 0 6px;
  color: #4a1428;
}

.ficha__titulo:first-child {
  margin-top: 4px;
}

.ficha__texto {
  font-size: 1.1rem;
  white-space: pre-line;
}

.ficha__vacio {
  font-style: italic;
  color: rgba(0, 0, 0, 0.5);
}

.ficha__lista {
  padding-left: 20px;
  font-size: 1.1rem;
}

.ficha__pie {
  margin: 20px 0 0;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.55);
}

.listo {
  padding: 12px 14px;
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-left: 5px solid #2e7d5b;
  border-radius: 8px;
}

.listo__cabecera {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

.listo__mesa {
  display: flex;
  align-items: center;
  font-size: 1.25rem;
  font-weight: 700;
}

.listo__tiempo {
  font-size: 0.95rem;
  font-weight: 600;
  color: #2e7d5b;
}

.listo__lineas {
  display: flex;
  flex-direction: column;
  margin-top: 6px;
  font-size: 1.05rem;
}

.listo__lineas em {
  color: #7a4b00;
  font-weight: 600;
}

.cocina__silenciar {
  animation: cocina-activar 0.9s ease-in-out infinite;
}

.cocina__activar {
  animation: cocina-activar 1.2s ease-in-out infinite;
}

@keyframes cocina-activar {
  50% {
    transform: scale(1.06);
  }
}

.cocina__atrasados {
  display: flex;
  align-items: center;
  padding: 2px 12px;
  border-radius: 999px;
  color: #c62828;
  background: #fdecea;
}

.cocina__titulo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 10px 16px;
  border-radius: 12px;
  font-size: 1.25rem;
  font-weight: 700;
  color: #fff;
}

.cocina__titulo--recibidas {
  background: #a31d48;
}

.cocina__titulo--preparando {
  background: #2e7d5b;
}

.cocina__orden {
  margin-left: 4px;
  font-size: 0.85rem;
  font-weight: 500;
  opacity: 0.85;
}

.cocina__conteo {
  min-width: 36px;
  padding: 0 10px;
  border-radius: 999px;
  text-align: center;
  font-size: 1.15rem;
  background: rgba(255, 255, 255, 0.25);
}

.cocina__tarjetas {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 14px;
}

.cocina__vacio {
  padding: 48px 16px;
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
  border: 2px dashed rgba(0, 0, 0, 0.12);
  border-radius: 12px;
}

.cocina__vacio p {
  margin: 8px 0 0;
  font-size: 1.05rem;
}
</style>
